<template>
  <div class="">
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{ tab.title }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "PersonReportTabs",
  data() {
    return {
      tabs: [
        {title: ' گزارش خریداران ', buyerOrSeller: 'buyer'},
        {title: 'گزارش فروشندگان', buyerOrSeller: 'seller'},
      ]
    };
  },
  props: {
    buyerOrSeller: {
      default: 'buyer'
    },
  },
  mounted() {
  },
  computed: {
    selectedTab() {
      if (this.buyerOrSeller == "buyer") {
        return 0
      } else {
        return 1
      }
    },
  },
  methods: {
    to(type) {
      return {
        name: "personReport",
        params: {
          buyerOrSeller: type,
        },
      };
    },

    changeRoute(tab) {
      this.$router.push(this.to(tab.buyerOrSeller))
    }
  }

};
</script>

<style scoped lang="scss">
</style>

